import { Component, OnInit, Input } from '@angular/core';
import { Device } from '../../../../../../models/device';
import { ConfigService } from '../../../../../config.service';
import { DataStorageService } from '../../../../../data-storage.service';
import { BagElement } from '../../../../../../models/bagElement';
import { ApiService } from '../../../../../api.service';
import { SecurityService } from '../../../../../security.service';
import { ApiBagService } from '../../../../../apiServices/bag/api-bag.service';

@Component({
  selector: 'app-device-for-sale',
  templateUrl: './device-for-sale.component.html',
  styleUrls: ['./device-for-sale.component.scss']
})
export class DeviceForSaleComponent implements OnInit {
  @Input()
  device: Device;
  value: number;
  distributorPrice: number;
  newSalePrice: number;
  isActive: boolean;

  constructor(
    private configService: ConfigService,
    public dataStorageService: DataStorageService,
    private api: ApiService,
    private bagApi: ApiBagService,
    private securityService: SecurityService) {
    this.value = 1;
    this.newSalePrice = 0;
    this.isActive = false;
  }

  ngOnInit() {
    this.distributorPrice = this.device.salePrice;
    this.isActive = this.device.hasChildrenDevices;
  }

  addToBag(dev: Device) {
    if (this.value !== 0 && this.dataStorageService.currentState.status === 'OPEN') {
      const device = new BagElement(dev, this.value);
      this.dataStorageService.currentState.deviceBag.push(device);
      this.dataStorageService.currentState.mergeBagElements();
      const updated = this.dataStorageService.currentState.deviceBag.filter(element => element.device.id === dev.id);
      this.bagApi.putBagDevice(dev.id, updated[0].quantity);
      this.dataStorageService.success = !this.dataStorageService.success;
      setTimeout(() => this.dataStorageService.success = false, 1000);
    }
  }

  decrease() {
    if (this.value > 0) {
      this.value--;
    }
  }

  increase() {
    this.value++;
  }

  // changePrice() {
  //   this.dataStorageService.devicePricePopup = this.dataStorageService.devicePricePopup === this.device.id ? -1 : this.device.id;
  // }

  // setSalePrice(event) {
  //   this.newSalePrice = event.target.value * 100;
  // }

  saveDevicePrice() {

    const categoryIDs = [];
    this.dataStorageService.categoriesGlobal.forEach((e) => categoryIDs.push(e.id));
    const categoryIndex = categoryIDs.indexOf(this.device.categoryId);

    const body = {
      'articleNo': '',
      'articleUrl': this.device.articleUrl,
      'name': this.device.name,
      'description': this.device.description,
      'manufacturer': '',
      'distributor': '',
      'purchasePrice': this.device.purchasePrice,
      'salePrice': this.device.salePrice,
      'visible': false,
      'imageUrl': this.device.imageUrl,
      'categoryId': this.dataStorageService.categories[categoryIndex].id,
      'partnerId': this.securityService.authorization.user.partnerId,
      'parentDeviceId': this.device.id,
      'hasChildrenDevices': true,
    };

    if (!this.isActive) {
      this.api.postDevice(body).then(dev => {
        this.isActive = true;
        this.dataStorageService.devices.push(dev);
        this.dataStorageService.devicePricePopup = -1;

        this.dataStorageService.successMyDev = !this.dataStorageService.successMyDev;
        setTimeout(() => this.dataStorageService.successMyDev = false, 1000);
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/content/new-offer/peoplephone-devices-data-base/device-catalogue/device-for-sale/device-for-sale.component.ts